export default __webpack_public_path__ + "static/media/bullhorn.450caa7b.svg";